import { render, staticRenderFns } from "./cards-config.vue?vue&type=template&id=10566eba"
import script from "./cards-config.vue?vue&type=script&lang=js"
export * from "./cards-config.vue?vue&type=script&lang=js"
import style0 from "./cards-config.vue?vue&type=style&index=0&id=10566eba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports